module.exports = __webpack_public_path__ + "img/ratio.71eb4c4b.svg";